module.exports = __webpack_public_path__ + "assets/a6a419f25813cd8c9dd07faaf95ff289.png";